import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { createStyles, getStylesRef } from '@mantine/core'

export default createStyles((theme) => {
  return {
    leadWrapper: {
      [theme.fn.smallerThan('sm')]: {
        padding: 0,
      },
      [theme.fn.largerThan('sm')]: {
        padding: '60px 0',
        backgroundImage:
          'linear-gradient(139.59deg, #182EF3 2.87%, #021575 89.05%)',
        position: 'relative',
        '&:before,&:after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top',
        },
        '&:before': {
          backgroundImage: `url(${CommonGAssets.getAssetPath(
            'tiki/top-bg.png',
          )})`,
          backgroundSize: 'contain',
        },
        '&:after': {
          backgroundImage: `url(${CommonGAssets.getAssetPath(
            'tiki/icon-bg.png',
          )})`,
          backgroundSize: '95%',
        },
      },

      '.mantine-LeadgenWithBanner-root': {
        position: 'relative',
        zIndex: 1,
      },
    },
    leadRoot: {
      backgroundColor: '#fff !important' as any,
      [theme.fn.largerThan('sm')]: {
        paddingBottom: 0,
        backgroundColor: 'transparent !important' as any,
      },
    },
    leadModalRoot: {
      ref: getStylesRef('leadModalRoot'),
      '.form-wrapper': {
        // width: 600,
      },
      '.action-list': {
        display: 'flex',
        justifyContent: 'flex-end',
      },
      '.banner-img': {
        [theme.fn.largerThan('sm')]: {
          // maxWidth: 600,
          maxHeight: 600,
        },
      },
      '.banner-wrapper,.form-wrapper': {
        flex: 'none',
      },
      '.mantine-Form-container': {
        justifyContent: 'space-evenly',
      },
    },
    leadModalWrapper: {
      // '.form-heading': {
      //   [theme.fn.largerThan('sm')]: { fontSize: 22, lineHeight: rem(32) },
      // },
      '.banner-img': {
        maxHeight: 500,
        maxWidth: 450,
      },
      '.mantine-Form-container': {
        height: 560,
      },
      '.mantine-Form-formFrame': {
        maxWidth: 416,
        // paddingTop: 24,
        // paddingLeft: 32,
        // paddingBottom: 16,
      },
      '.mantine-Form-formSubmitBtnWrapper': {
        // paddingTop: 8,
      },
      '.mantine-SuccessBox-description': {
        textAlign: 'left',
      },
      '.mantine-SuccessBox-img': {
        height: 120,
      },
    },
    leadInlineRoot: {
      backgroundColor: '#fff !important' as any,
      [theme.fn.smallerThan('sm')]: {
        padding: '0 !important' as any,
        '.banner-wrapper': {
          marginLeft: -16,
          marginRight: -16,
        },
      },
      [theme.fn.largerThan('sm')]: {
        backgroundColor: 'transparent !important' as any,
        padding: 0,
      },
      '.banner-wrapper,.form-wrapper': {
        flex: 'none',
      },
      '.action-list': {
        display: 'flex',
        justifyContent: 'flex-end',
      },
      '.banner-img': {
        [theme.fn.largerThan('sm')]: {
          // maxWidth: 600,
          // maxHeight: 600,
        },
      },
      '.mantine-SuccessBox-description': {
        textAlign: 'left',
      },
    },
    leadFormFrame: {
      [theme.fn.smallerThan('sm')]: {
        background: '#fff',
        padding: 0,
        paddingBottom: 16,
      },
      [theme.fn.largerThan('sm')]: {
        maxWidth: 456,
      },
      // '.tnc-block': {
      //   marginTop: 0,
      // },
    },
  }
})
